<kpi-tab-content #managementControlTab [tabIndex]="0">
  <kpi-group #unsignedContractsGroup [title]="'Firma de contratos'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (managementControlPastUnsignedContractsHostVisible) {
      <kpi-host #managementControlPastUnsignedContractsHost [title]="'Ctr/pro/fin ctr pdtes firmar caducados'"
        tooltip="Contratos, prórrogas y fin de contratos pendientes de firmar caducados: Se muestra contratos de máximo 15 dias para atrás"
        [refreshing]="managementControlPastUnsignedContractsServiceHost.loading"
        [warn]="managementControlPastUnsignedContractsServiceHost.warn"
        [lastUpdatedText]="managementControlPastUnsignedContractsServiceHost.lastUpdatedText"
        (detailRequested)="managementControlPastUnsignedContractsServiceHost.showDetail($event)">
        <i icon class="material-icons">border_color</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlPastUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
        <past-unsigned-contracts-direct-kpi-service-host sink #managementControlPastUnsignedContractsServiceHost
          [detailDialog]="managementControlPastUnsignedContractsDetailDialog">
        </past-unsigned-contracts-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlPastUnsignedContractsServiceHost.summaryData &&
          !managementControlPastUnsignedContractsServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlPastUnsignedContractsServiceHost.summaryData) {
          <dual-data #managementControlPastUnsignedContractsDualData
            [valueA]="managementControlPastUnsignedContractsServiceHost.summaryData.consultant"
            [valueAStyle]="managementControlPastUnsignedContractsServiceHost.summaryData.consultant == 0 && !managementControlPastUnsignedContractsServiceHost.warn ? managementControlPastUnsignedContractsDualData.dataValueStyle.Zero : managementControlPastUnsignedContractsDualData.dataValueStyle.None"
            [iconA]="managementControlPastUnsignedContractsDualData.dataIcon.User"
            (valueAClick)="managementControlPastUnsignedContractsServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlPastUnsignedContractsServiceHost.summaryData.office"
            [valueBStyle]="managementControlPastUnsignedContractsServiceHost.summaryData.office == 0 && !managementControlPastUnsignedContractsServiceHost.warn ? managementControlPastUnsignedContractsDualData.dataValueStyle.Zero : managementControlPastUnsignedContractsDualData.dataValueStyle.None"
            [iconB]="managementControlPastUnsignedContractsDualData.dataIcon.Office"
            (valueBClick)="managementControlPastUnsignedContractsServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlPastUnsignedContractsServiceHost.summaryError) {
        <data-error errorMsg [errorMessage]="managementControlPastUnsignedContractsServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlPastUnsignedContractsServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlPastUnsignedContractsDetailDialog
          [title]="'Contratos, prórrogas y fin de contratos pendientes de firmar caducados'" cancelText="Cerrar"
          [size]="managementControlPastUnsignedContractsDetailDialog.dialogSize.Large">
          @if (managementControlPastUnsignedContractsDetailDialog.visible &&
          managementControlPastUnsignedContractsServiceHost.detailData) {
          <multiview #managementControlPastUnsignedContractsDetailDialogMultiview>
            <datatable *multiviewContent
              [columnDefinitions]="managementControlPastUnsignedContractsServiceHost.detailData.columnDefinitions"
              [data]="managementControlPastUnsignedContractsServiceHost.detailData.tabledata"
              (onCellAction)="managementControlPastUnsignedContractsServiceHost.handleDatatableCellAction($event, managementControlPastUnsignedContractsDetailDialogMultiview)">
            </datatable>
            <send-sms [data]="data" *multiviewContent="let data=sendSMSData">
            </send-sms>
            <action-result [data]="data" *multiviewContent="let data=actionResultData">
            </action-result>
          </multiview>
          }

          @if (managementControlPastUnsignedContractsDetailDialog.visible &&
          managementControlPastUnsignedContractsServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }

      @if (managementControlInmediateUnsignedContractsHostVisible) {
      <kpi-host #managementControlInmediateUnsignedContractsHost [title]="'Ctr/pro/fin ctr pdtes firmar hoy y mañana'"
        tooltip="Contratos, prórrogas y fin de contratos pendientes de firmar hoy y mañana. Tiene en cuenta los fines de semana"
        [refreshing]="managementControlInmediateUnsignedContractsServiceHost.loading"
        [warn]="managementControlInmediateUnsignedContractsServiceHost.warn"
        [lastUpdatedText]="managementControlInmediateUnsignedContractsServiceHost.lastUpdatedText"
        (detailRequested)="managementControlInmediateUnsignedContractsServiceHost.showDetail($event)">
        <i icon class="material-icons">border_color</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlInmediateUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
        <inmediate-unsigned-contracts-direct-kpi-service-host sink
          #managementControlInmediateUnsignedContractsServiceHost
          [detailDialog]="managementControlInmediateUnsignedContractsDetailDialog">
        </inmediate-unsigned-contracts-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlInmediateUnsignedContractsServiceHost.summaryData &&
          !managementControlInmediateUnsignedContractsServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlInmediateUnsignedContractsServiceHost.summaryData) {
          <dual-data #managementControlInmediateUnsignedContractsDualData
            [valueA]="managementControlInmediateUnsignedContractsServiceHost.summaryData.consultant"
            [valueAStyle]="managementControlInmediateUnsignedContractsServiceHost.summaryData.consultant == 0 ? managementControlInmediateUnsignedContractsDualData.dataValueStyle.Zero : managementControlInmediateUnsignedContractsDualData.dataValueStyle.Warn"
            [iconA]="managementControlInmediateUnsignedContractsDualData.dataIcon.User"
            (valueAClick)="managementControlInmediateUnsignedContractsServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlInmediateUnsignedContractsServiceHost.summaryData.office"
            [valueBStyle]="managementControlInmediateUnsignedContractsServiceHost.summaryData.office == 0 ? managementControlInmediateUnsignedContractsDualData.dataValueStyle.Zero : managementControlInmediateUnsignedContractsDualData.dataValueStyle.Warn"
            [iconB]="managementControlInmediateUnsignedContractsDualData.dataIcon.Office"
            (valueBClick)="managementControlInmediateUnsignedContractsServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlInmediateUnsignedContractsServiceHost.summaryError) {
        <data-error errorMsg
          [errorMessage]="managementControlInmediateUnsignedContractsServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlInmediateUnsignedContractsServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlInmediateUnsignedContractsDetailDialog
          [title]="'Contratos, prórrogas y fin de contratos pendientes de firmar hoy y mañana'" cancelText="Cerrar"
          [size]="managementControlInmediateUnsignedContractsDetailDialog.dialogSize.Large">
          @if (managementControlInmediateUnsignedContractsDetailDialog.visible &&
          managementControlInmediateUnsignedContractsServiceHost.detailData) {
          <multiview #managementControlInmediateUnsignedContractsDetailDialogMultiview>
            <datatable *multiviewContent
              [columnDefinitions]="managementControlInmediateUnsignedContractsServiceHost.detailData.columnDefinitions"
              [data]="managementControlInmediateUnsignedContractsServiceHost.detailData.tabledata"
              (onCellAction)="managementControlInmediateUnsignedContractsServiceHost.handleDatatableCellAction($event, managementControlInmediateUnsignedContractsDetailDialogMultiview)">
            </datatable>
            <send-sms [data]="data" *multiviewContent="let data=sendSMSData">
            </send-sms>
            <action-result [data]="data" *multiviewContent="let data=actionResultData">
            </action-result>
          </multiview>
          }

          @if (managementControlInmediateUnsignedContractsDetailDialog.visible &&
          managementControlInmediateUnsignedContractsServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }

      @if (managementControlForecastUnsignedContractsHostVisible) {
      <kpi-host #managementControlForecastUnsignedContractsHost [title]="'Contratos pendiente firmar esta semana'"
        tooltip="Contratos pendientes de firmar esta semana"
        [refreshing]="managementControlForecastUnsignedContractsServiceHost.loading"
        [warn]="managementControlForecastUnsignedContractsServiceHost.warn"
        [lastUpdatedText]="managementControlForecastUnsignedContractsServiceHost.lastUpdatedText" [size]="2"
        [hostsLineChart]="true"
        (detailRequested)="managementControlForecastUnsignedContractsServiceHost.showDetailEx($event, { name: managementControlForecastUnsignedContractsSelector.selectedOption.text });">
        <i icon class="material-icons">border_color</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlForecastUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
        <unsigned-contracts-direct-evolution-kpi-service-host sink
          #managementControlForecastUnsignedContractsServiceHost
          [detailDialog]="managementControlForecastUnsignedContractsDetailDialog">
        </unsigned-contracts-direct-evolution-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlForecastUnsignedContractsServiceHost.summaryData &&
          !managementControlForecastUnsignedContractsServiceHost.summaryError) {
          <no-data></no-data>
          }
        </ng-container>
        <ng-container additionalData>
          <chart-dropdown #managementControlForecastUnsignedContractsSelector
            [hidden]="!managementControlForecastUnsignedContractsServiceHost.summaryData"
            [options]="managementControlForecastUnsignedContractsServiceHost.summaryData">
          </chart-dropdown>
          @if (managementControlForecastUnsignedContractsServiceHost.summaryData) {
          <line-chart [data]="managementControlForecastUnsignedContractsSelector.selectedOption.value.lineChartData"
            [isVisible]="managementControlTab.isVisible"
            (clickData)="managementControlForecastUnsignedContractsServiceHost.mergeFilter({ date: managementControlForecastUnsignedContractsSelector.selectedOption.value.dates[$event.dataIndices[0]] })">
          </line-chart>
          }
        </ng-container>
        @if (managementControlForecastUnsignedContractsServiceHost.summaryError) {
        <data-error errorMsg [errorMessage]="managementControlForecastUnsignedContractsServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlForecastUnsignedContractsServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlForecastUnsignedContractsDetailDialog
          [title]="'Contratos pendiente firmar esta semana'" cancelText="Cerrar"
          [size]="managementControlForecastUnsignedContractsDetailDialog.dialogSize.Large">
          @if (managementControlForecastUnsignedContractsDetailDialog.visible &&
          managementControlForecastUnsignedContractsServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlForecastUnsignedContractsServiceHost.detailData.columnDefinitions"
            [data]="managementControlForecastUnsignedContractsServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlForecastUnsignedContractsDetailDialog.visible &&
          managementControlForecastUnsignedContractsServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #expiringContractsGroup [title]="'Vencimientos'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (managementControlPastExpiringContractsHostVisible) {
      <kpi-host #managementControlPastExpiringContractsHost [title]="'Vtos. contratos caducados'"
        tooltip="Vencimientos de contratos caducados: Contratos que no has informado la baja o prórroga (15 días para atrás)"
        [refreshing]="managementControlPastExpiringContractsServiceHost.loading"
        [warn]="managementControlPastExpiringContractsServiceHost.warn"
        [lastUpdatedText]="managementControlPastExpiringContractsServiceHost.lastUpdatedText"
        (detailRequested)="managementControlPastExpiringContractsServiceHost.showDetail($event)">
        <i icon class="material-icons">date_range</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlPastExpiringContractsServiceHost.refresh()"></kpi-host-menu-option>
        <past-expiring-contracts-direct-kpi-service-host sink #managementControlPastExpiringContractsServiceHost
          [detailDialog]="managementControlPastExpiringContractsDetailDialog">
        </past-expiring-contracts-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlPastExpiringContractsServiceHost.summaryData &&
          !managementControlPastExpiringContractsServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlPastExpiringContractsServiceHost.summaryData) {
          <dual-data #managementControlPastExpiringContractsDualData
            [valueA]="managementControlPastExpiringContractsServiceHost.summaryData.consultant"
            [valueAStyle]="managementControlPastExpiringContractsServiceHost.summaryData.consultant == 0 && !managementControlPastExpiringContractsServiceHost.warn ? managementControlPastExpiringContractsDualData.dataValueStyle.Zero : managementControlPastExpiringContractsDualData.dataValueStyle.None"
            [iconA]="managementControlPastExpiringContractsDualData.dataIcon.User"
            (valueAClick)="managementControlPastExpiringContractsServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlPastExpiringContractsServiceHost.summaryData.office"
            [valueBStyle]="managementControlPastExpiringContractsServiceHost.summaryData.office == 0 && !managementControlPastExpiringContractsServiceHost.warn ? managementControlPastExpiringContractsDualData.dataValueStyle.Zero : managementControlPastExpiringContractsDualData.dataValueStyle.None"
            [iconB]="managementControlPastExpiringContractsDualData.dataIcon.Office"
            (valueBClick)="managementControlPastExpiringContractsServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlPastExpiringContractsServiceHost.summaryError) {
        <data-error errorMsg [errorMessage]="managementControlPastExpiringContractsServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlPastExpiringContractsServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlPastExpiringContractsDetailDialog
          [title]="'Vencimiento de contratos caducados'" cancelText="Cerrar"
          [size]="managementControlPastExpiringContractsDetailDialog.dialogSize.Large">
          @if (managementControlPastExpiringContractsDetailDialog.visible &&
          managementControlPastExpiringContractsServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlPastExpiringContractsServiceHost.detailData.columnDefinitions"
            [data]="managementControlPastExpiringContractsServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlPastExpiringContractsDetailDialog.visible &&
          managementControlPastExpiringContractsServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }

      @if (managementControlInmediateExpiringContractsHostVisible) {
      <kpi-host #managementControlInmediateExpiringContractsHost [title]="'Vtos. contratos hoy'"
        tooltip="Vencimientos de Contratos Hoy: Contratos activos cuya fecha fin prevista de finalización es hoy"
        [refreshing]="managementControlInmediateExpiringContractsServiceHost.loading"
        [warn]="managementControlInmediateExpiringContractsServiceHost.warn"
        [lastUpdatedText]="managementControlInmediateExpiringContractsServiceHost.lastUpdatedText"
        (detailRequested)="managementControlInmediateExpiringContractsServiceHost.showDetail($event)">
        <i icon class="material-icons">date_range</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlInmediateExpiringContractsServiceHost.refresh()"></kpi-host-menu-option>
        <inmediate-expiring-contracts-direct-kpi-service-host sink
          #managementControlInmediateExpiringContractsServiceHost
          [detailDialog]="managementControlInmediateExpiringContractsDetailDialog">
        </inmediate-expiring-contracts-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlInmediateExpiringContractsServiceHost.summaryData &&
          !managementControlInmediateExpiringContractsServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlInmediateExpiringContractsServiceHost.summaryData) {
          <dual-data #managementControlInmediateExpiringContractsDualData
            [valueA]="managementControlInmediateExpiringContractsServiceHost.summaryData.consultant"
            [iconA]="managementControlInmediateExpiringContractsDualData.dataIcon.User"
            (valueAClick)="managementControlInmediateExpiringContractsServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlInmediateExpiringContractsServiceHost.summaryData.office"
            [iconB]="managementControlInmediateExpiringContractsDualData.dataIcon.Office"
            (valueBClick)="managementControlInmediateExpiringContractsServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>

        @if (managementControlInmediateExpiringContractsServiceHost.summaryError) {
        <data-error errorMsg
          [errorMessage]="managementControlInmediateExpiringContractsServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlInmediateExpiringContractsServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlInmediateExpiringContractsDetailDialog
          [title]="'Vencimientos de contratos hoy'" cancelText="Cerrar"
          [size]="managementControlInmediateExpiringContractsDetailDialog.dialogSize.Large">
          @if (managementControlInmediateExpiringContractsDetailDialog.visible &&
          managementControlInmediateExpiringContractsServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlInmediateExpiringContractsServiceHost.detailData.columnDefinitions"
            [data]="managementControlInmediateExpiringContractsServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlInmediateExpiringContractsDetailDialog.visible &&
          managementControlInmediateExpiringContractsServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }

      @if (managementControlForecastExpiringContractsHostVisible) {
      <kpi-host #managementControlForecastExpiringContractsHost
        [title]="'Vencimiento contratos fecha prevista esta semana'"
        tooltip="Contratos activos con fecha fin prevista de finalización en esta semana"
        [refreshing]="managementControlForecastExpiringContractsServiceHost.loading"
        [warn]="managementControlForecastExpiringContractsServiceHost.warn"
        [lastUpdatedText]="managementControlForecastExpiringContractsServiceHost.lastUpdatedText" [size]="2"
        [hostsBarChart]="true"
        (detailRequested)="managementControlForecastExpiringContractsServiceHost.showDetailEx($event, { name: managementControlForecastExpiringContractsSelector.selectedOption.text });">
        <i icon class="material-icons">date_range</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlForecastExpiringContractsServiceHost.refresh()"></kpi-host-menu-option>
        <expiring-contracts-direct-evolution-kpi-service-host sink
          #managementControlForecastExpiringContractsServiceHost
          [detailDialog]="managementControlForecastExpiringContractsDetailDialog">
        </expiring-contracts-direct-evolution-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlForecastExpiringContractsServiceHost.summaryData &&
          !managementControlForecastExpiringContractsServiceHost.summaryError) {
          <no-data></no-data>
          }

        </ng-container>
        <ng-container additionalData>
          <chart-dropdown #managementControlForecastExpiringContractsSelector
            [hidden]="!managementControlForecastExpiringContractsServiceHost.summaryData"
            [options]="managementControlForecastExpiringContractsServiceHost.summaryData">
          </chart-dropdown>
          @if (managementControlForecastExpiringContractsServiceHost.summaryData) {
          <bar-chart additionalData
            [data]="managementControlForecastExpiringContractsSelector.selectedOption.value.barChartData"
            [isVisible]="managementControlTab.isVisible" [showLegend]="false"
            (clickData)="managementControlForecastExpiringContractsServiceHost.mergeFilter({ date: managementControlForecastExpiringContractsSelector.selectedOption.value.dates[$event.dataIndices[0]] })">
          </bar-chart>
          }
        </ng-container>
        @if (managementControlForecastExpiringContractsServiceHost.summaryError) {
        <data-error errorMsg [errorMessage]="managementControlForecastExpiringContractsServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlForecastExpiringContractsServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlForecastExpiringContractsDetailDialog
          [title]="'Vencimiento contratos fecha prevista esta semana'" cancelText="Cerrar"
          [size]="managementControlForecastExpiringContractsDetailDialog.dialogSize.Large">
          @if (managementControlForecastExpiringContractsDetailDialog.visible &&
          managementControlForecastExpiringContractsServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlForecastExpiringContractsServiceHost.detailData.columnDefinitions"
            [data]="managementControlForecastExpiringContractsServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlForecastExpiringContractsDetailDialog.visible &&
          managementControlForecastExpiringContractsServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #riskGroup [title]="'Riesgos'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (managementControlPendingActiveWorkersWoMedicalExaminationHostVisible) {
      <kpi-host #managementControlPendingActiveWorkersWoMedicalExaminationHost [title]="'RRMM obligatorio pend.'"
        tooltip="Trabajadores activos con  RRMM obligatorio pendiente de enviar al SPA"
        [refreshing]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.loading"
        [warn]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.warn"
        [lastUpdatedText]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
        (detailRequested)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
        <i icon class="material-icons">favorite_border</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
        <pending-active-workers-wo-medical-examination-direct-kpi-service-host sink
          #managementControlPendingActiveWorkersWoMedicalExaminationServiceHost
          [detailDialog]="managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog">
        </pending-active-workers-wo-medical-examination-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData &&
          !managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
          <dual-data #managementControlPendingActiveWorkersWoMedicalExaminationDualData
            [valueA]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
            [valueAStyle]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant == 0 ? managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
            [iconA]="managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
            (valueAClick)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
            [valueBStyle]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office == 0 ? managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
            [iconB]="managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
            (valueBClick)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
        <data-error errorMsg
          [errorMessage]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog
          [title]="'RRMM obligatorio pend.'" cancelText="Cerrar"
          [size]="managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
          @if (managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
            [data]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }

      @if (managementControlExpiredActiveWorkersWoMedicalExaminationHostVisible) {
      <kpi-host #managementControlExpiredActiveWorkersWoMedicalExaminationHost [title]="'RRMM no obligatorio pend.'"
        tooltip="Trabajadores activos con  RRMM no obligatorio pendiente de enviar al SPA"
        [refreshing]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.loading"
        [warn]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.warn"
        [lastUpdatedText]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
        (detailRequested)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
        <i icon class="material-icons">favorite_border</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
        <expired-active-workers-wo-medical-examination-direct-kpi-service-host sink
          #managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost
          [detailDialog]="managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog">
        </expired-active-workers-wo-medical-examination-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData &&
          !managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
          <dual-data #managementControlExpiredActiveWorkersWoMedicalExaminationDualData
            [valueA]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
            [iconA]="managementControlExpiredActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
            (valueAClick)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
            [iconB]="managementControlExpiredActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
            (valueBClick)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
        <data-error errorMsg
          [errorMessage]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog
          [title]="'RRMM no obligatorio pend.'" cancelText="Cerrar"
          [size]="managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
          @if (managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
            [data]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }
      @if (managementControlProcessingActiveWorkersWoMedicalExaminationHostVisible) {
      <kpi-host #managementControlProcessingActiveWorkersWoMedicalExaminationHost [title]="'RRMM en proceso'"
        tooltip="Trabajadores activos con  RRMM en proceso"
        [refreshing]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.loading"
        [warn]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.warn"
        [lastUpdatedText]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
        (detailRequested)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
        <i icon class="material-icons">favorite_border</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
        <processing-active-workers-wo-medical-examination-direct-kpi-service-host sink
          #managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost
          [detailDialog]="managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog">
        </processing-active-workers-wo-medical-examination-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData &&
          !managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
          <dual-data #managementControlProcessingActiveWorkersWoMedicalExaminationDualData
            [valueA]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
            [valueAStyle]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant == 0 ? managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
            [iconA]="managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
            (valueAClick)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
            [valueBStyle]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office == 0 ? managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
            [iconB]="managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
            (valueBClick)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
        <data-error errorMsg
          [errorMessage]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog
          [title]="'RRMM en proceso'" cancelText="Cerrar"
          [size]="managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
          @if (managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
            [data]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }

      @if (managementControlFitActiveWorkersWoMedicalExaminationHostVisible) {
      <kpi-host #managementControlFitActiveWorkersWoMedicalExaminationHost [title]="'RRMM aptos'"
        tooltip="Trabajadores activos con  RRMM Apto"
        [refreshing]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.loading"
        [warn]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.warn"
        [lastUpdatedText]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
        (detailRequested)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
        <i icon class="material-icons">favorite_border</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
        <fit-active-workers-wo-medical-examination-direct-kpi-service-host sink
          #managementControlFitActiveWorkersWoMedicalExaminationServiceHost
          [detailDialog]="managementControlFitActiveWorkersWoMedicalExaminationDetailDialog">
        </fit-active-workers-wo-medical-examination-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData &&
          !managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
          <dual-data #managementControlFitActiveWorkersWoMedicalExaminationDualData
            [valueA]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
            [iconA]="managementControlFitActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
            (valueAClick)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
            [iconB]="managementControlFitActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
            (valueBClick)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
        <data-error errorMsg
          [errorMessage]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlFitActiveWorkersWoMedicalExaminationDetailDialog
          [title]="'RRMM aptos'" cancelText="Cerrar"
          [size]="managementControlFitActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
          @if (managementControlFitActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailData) {
          <datatable
            [columnDefinitions]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
            [data]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlFitActiveWorkersWoMedicalExaminationDetailDialog.visible &&
          managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }
    </kpi-group-row>
    <kpi-group-row>
      @if (managementControlActiveWorkersWoPPEHostVisible) {
      <kpi-host #managementControlActiveWorkersWoPPEHost [title]="'Trab. activos sin epi'"
        tooltip="Trabajadores activos sin epi: Trabajadores que has quedado con el cliente que vas a entregar epis y no los tienen"
        [refreshing]="managementControlActiveWorkersWoPPEServiceHost.loading"
        [warn]="managementControlActiveWorkersWoPPEServiceHost.warn"
        [lastUpdatedText]="managementControlActiveWorkersWoPPEServiceHost.lastUpdatedText"
        (detailRequested)="managementControlActiveWorkersWoPPEServiceHost.showDetail($event)">
        <i icon class="icon ico-helmet"></i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlActiveWorkersWoPPEServiceHost.refresh()"></kpi-host-menu-option>
        <active-workers-wo-mandatory-ppe-direct-kpi-service-host sink #managementControlActiveWorkersWoPPEServiceHost
          [detailDialog]="managementControlActiveWorkersWoPPEDetailDialog">
        </active-workers-wo-mandatory-ppe-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlActiveWorkersWoPPEServiceHost.summaryData &&
          !managementControlActiveWorkersWoPPEServiceHost.summaryError) {
          <no-data></no-data>
          }

          @if (managementControlActiveWorkersWoPPEServiceHost.summaryData) {
          <dual-data #managementControlActiveWorkersWoPPEDualData
            [valueA]="managementControlActiveWorkersWoPPEServiceHost.summaryData.consultant"
            [valueAStyle]="managementControlActiveWorkersWoPPEServiceHost.summaryData.consultant == 0 ? managementControlActiveWorkersWoPPEDualData.dataValueStyle.Zero : managementControlActiveWorkersWoPPEDualData.dataValueStyle.Warn"
            [iconA]="managementControlActiveWorkersWoPPEDualData.dataIcon.User"
            (valueAClick)="managementControlActiveWorkersWoPPEServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlActiveWorkersWoPPEServiceHost.summaryData.office"
            [valueBStyle]="managementControlActiveWorkersWoPPEServiceHost.summaryData.office == 0 ? managementControlActiveWorkersWoPPEDualData.dataValueStyle.Zero : managementControlActiveWorkersWoPPEDualData.dataValueStyle.Warn"
            [iconB]="managementControlActiveWorkersWoPPEDualData.dataIcon.Office"
            (valueBClick)="managementControlActiveWorkersWoPPEServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlActiveWorkersWoPPEServiceHost.summaryError) {
        <data-error errorMsg [errorMessage]="managementControlActiveWorkersWoPPEServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlActiveWorkersWoPPEServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlActiveWorkersWoPPEDetailDialog
          [title]="'Trabajadores activos sin epi'" cancelText="Cerrar"
          [size]="managementControlActiveWorkersWoPPEDetailDialog.dialogSize.Large">
          @if (managementControlActiveWorkersWoPPEDetailDialog.visible &&
          managementControlActiveWorkersWoPPEServiceHost.detailData) {
          <datatable [columnDefinitions]="managementControlActiveWorkersWoPPEServiceHost.detailData.columnDefinitions"
            [data]="managementControlActiveWorkersWoPPEServiceHost.detailData.tabledata">
          </datatable>
          }

          @if (managementControlActiveWorkersWoPPEDetailDialog.visible &&
          managementControlActiveWorkersWoPPEServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }
      @if (managementControlAbsencesHostVisible) {
      <kpi-host #managementControlAbsencesHost [title]="'Control absentismos'"
        tooltip="IT´s Accidentes y permiso maternidad y paternidad"
        [refreshing]="managementControlAbsencesServiceHost.loading" [warn]="managementControlAbsencesServiceHost.warn"
        [lastUpdatedText]="managementControlAbsencesServiceHost.lastUpdatedText"
        (detailRequested)="managementControlAbsencesServiceHost.showDetail($event)">
        <i icon class="material-icons">border_color</i>
        <kpi-host-menu-option menuOption [text]="'Actualizar'"
          (click)="managementControlAbsencesServiceHost.refresh()"></kpi-host-menu-option>
        <absences-direct-kpi-service-host sink #managementControlAbsencesServiceHost
          [detailDialog]="managementControlAbsencesDetailDialog">
        </absences-direct-kpi-service-host>
        <ng-container mainData>
          @if (!managementControlAbsencesServiceHost.summaryData && !managementControlAbsencesServiceHost.summaryError)
          {
          <no-data></no-data>
          }

          @if (managementControlAbsencesServiceHost.summaryData) {
          <dual-data #managementControlAbsencesDualData
            [valueA]="managementControlAbsencesServiceHost.summaryData.consultant"
            [valueAStyle]="managementControlAbsencesServiceHost.summaryData.consultant == 0 && !managementControlAbsencesServiceHost.warn ? managementControlAbsencesDualData.dataValueStyle.Zero : managementControlAbsencesDualData.dataValueStyle.None"
            [iconA]="managementControlAbsencesDualData.dataIcon.User"
            (valueAClick)="managementControlAbsencesServiceHost.mergeFilter({ consultant: true })"
            [valueB]="managementControlAbsencesServiceHost.summaryData.office"
            [valueBStyle]="managementControlAbsencesServiceHost.summaryData.office == 0 && !managementControlAbsencesServiceHost.warn ? managementControlAbsencesDualData.dataValueStyle.Zero : managementControlAbsencesDualData.dataValueStyle.None"
            [iconB]="managementControlAbsencesDualData.dataIcon.Office"
            (valueBClick)="managementControlAbsencesServiceHost.mergeFilter({ consultant: false })">
          </dual-data>
          }
        </ng-container>
        @if (managementControlAbsencesServiceHost.summaryError) {
        <data-error errorMsg [errorMessage]="managementControlAbsencesServiceHost.summaryError.message"
          (onRequestRefresh)="managementControlAbsencesServiceHost.refresh()">
        </data-error>
        }

        <modal-dialog detailDialog #managementControlAbsencesDetailDialog [title]="'Control absentismos'"
          cancelText="Cerrar" [size]="managementControlAbsencesDetailDialog.dialogSize.Large">
          @if (managementControlAbsencesDetailDialog.visible && managementControlAbsencesServiceHost.detailData) {
          <datatable [columnDefinitions]="managementControlAbsencesServiceHost.detailData.columnDefinitions"
            [data]="managementControlAbsencesServiceHost.detailData.tabledata"
            [rowStyleSelector]="managementControlAbsencesServiceHost.detailData.rowStyleSelector">
          </datatable>
          }

          @if (managementControlAbsencesDetailDialog.visible && managementControlAbsencesServiceHost.detailError) {
          <div style="display: flex; flex-direction: column; align-items: center;">
            <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
            <span class="msg-error-title">Ups! Tenemos un problema</span>
          </div>
          }
        </modal-dialog>
      </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>
</kpi-tab-content>